import { _ as _extends } from '../../extends-30811c5e.js';
import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-dd908bcc.js';
import React__default from 'react';
import classNames from 'classnames';

var _excluded = ["highlightColor", "size", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/* eslint-disable @typescript-eslint/no-unused-vars */

var IconSettings = function IconSettings(_ref) {
  _ref.highlightColor;
    var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    newProps = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({
    width: size,
    height: size
  }, newProps), {}, {
    className: classNames('sol-icon', className)
  });
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React__default.createElement("g", {
    id: "icon-settings"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.86806 5.57297C4.66236 5.45421 4.40042 5.49572 4.25019 5.6797C3.57775 6.50326 3.03397 7.43599 2.64953 8.44724C2.5651 8.66931 2.66012 8.91702 2.86587 9.03581L5 10.2679C6.33334 11.0377 6.33334 12.9622 5 13.732L2.86587 14.9642C2.66012 15.083 2.5651 15.3307 2.64953 15.5528C3.03397 16.564 3.57775 17.4967 4.25019 18.3203C4.40042 18.5043 4.66236 18.5458 4.86806 18.427L6.99997 17.1962C8.33331 16.4264 9.99998 17.3886 9.99998 18.9282V21.3913C9.99998 21.6291 10.1673 21.8353 10.4021 21.873C10.9224 21.9566 11.4561 22 12 22C12.5439 22 13.0776 21.9566 13.5979 21.873C13.8327 21.8353 14 21.6291 14 21.3913V18.9282C14 17.3886 15.6666 16.4263 17 17.1961L19.132 18.4271C19.3377 18.5458 19.5996 18.5043 19.7499 18.3203C20.4223 17.4968 20.9661 16.564 21.3505 15.5528C21.435 15.3307 21.3399 15.083 21.1342 14.9642L19 13.7321C17.6667 12.9622 17.6667 11.0377 19 10.2679L21.1342 9.03578C21.3399 8.91699 21.435 8.66929 21.3505 8.44721C20.9661 7.43596 20.4223 6.50323 19.7499 5.67968C19.5996 5.4957 19.3377 5.45419 19.132 5.57295L17 6.80386C15.6666 7.57366 14 6.61141 14 5.07181V2.60873C14 2.37093 13.8327 2.16467 13.5979 2.12697C13.0776 2.04341 12.5439 2 12 2C11.4561 2 10.9224 2.04342 10.4021 2.12699C10.1673 2.16469 9.99998 2.37095 9.99998 2.60875V5.07178C9.99998 6.61138 8.33331 7.57363 6.99998 6.80383L4.86806 5.57297ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3432 9 9.00002 10.3431 9.00002 12C9.00002 13.6569 10.3432 15 12 15Z",
    fill: "currentColor"
  })));
};

export { IconSettings };
